export const SET_TABLE_ONE_EVENT_TPA_REPORT = 'SET_TABLE_ONE_EVENT_TPA_REPORT'
export const SET_TABLE_TWO_STOCK_TPA_REPORT = 'SET_TABLE_TWO_STOCK_TPA_REPORT'
export const SET_TABLE_THREE_SHRINKAGE_TPA_REPORT = 'SET_TABLE_THREE_SHRINKAGE_TPA_REPORT'
export const SET_TABLE_FOUR_ONSHORE_TPA_REPORT = 'SET_TABLE_FOUR_ONSHORE_TPA_REPORT'

